import {Controller} from '@hotwired/stimulus';
import Swiper from 'swiper';
import {Navigation, Pagination, Autoplay} from 'swiper/modules';
import 'swiper/scss';
import 'swiper/scss/pagination';
import 'swiper/scss/navigation';

export default class extends Controller {

    static values = {
        partenaires: Boolean
    }

    connect()
    {
        this.initSwiper(this.element);
    }

    initSwiper(elem)
    {
        let breakpoints = {};
        if (this.partenairesValue)
        {
            breakpoints = {
                0: {
                    slidesPerView: 1
                },
                768: {
                    slidesPerView: 3
                }
            }
        }
        else
        {
            breakpoints = {
                0: {
                    slidesPerView: 1
                }
            }
        }
        new Swiper(elem, {
            // configure Swiper to use modules
            modules: [Pagination, Navigation, Autoplay],
            slidesPerView: 1,
            spaceBetween: 50,
            speed: 1000,
            loop: true,
            autoplay: {
                delay: 2000,
                disableOnInteraction: false
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            // Responsive breakpoints
            breakpoints: breakpoints
        });
    }
}
